import { render, staticRenderFns } from "./StepperData.vue?vue&type=template&id=86bd84f0&scoped=true&"
import script from "./StepperData.vue?vue&type=script&lang=ts&"
export * from "./StepperData.vue?vue&type=script&lang=ts&"
import style0 from "./StepperData.vue?vue&type=style&index=0&id=86bd84f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bd84f0",
  null
  
)

export default component.exports